import { render, staticRenderFns } from "./CreateAgreementItemsModal.vue?vue&type=template&id=6cfe0ee3&"
import script from "./CreateAgreementItemsModal.vue?vue&type=script&lang=js&"
export * from "./CreateAgreementItemsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports